module.exports = __webpack_public_path__ + "static/media/l-md12.5bac4253.png";